import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppBreadcrumbModule } from '@coreui/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AppMaterialModule } from '../../../app-material/app-material.module';
import { DatePickerModule } from '../../datePicker/date-picker/date-picker.module';
import { PdfExporterModule } from '../../pdf-exporter/pdf-exporter.module';
import { GroupStatisticsCardModule } from '../group-statistics-card/group-statistics-card.module';
import { GroupCustomStatisticsComponent } from './group-custom-statistics.component';

@NgModule({
  declarations: [GroupCustomStatisticsComponent],
  entryComponents: [GroupCustomStatisticsComponent],
  imports: [
    CommonModule,
    FormsModule,
    AppMaterialModule,
    ChartsModule,
    TranslateModule,
    AppBreadcrumbModule,
    TranslateModule,
    NgxDaterangepickerMd,
    DatePickerModule,
    GroupStatisticsCardModule,
    PdfExporterModule
  ],
  providers: [
    ThemeService
  ],
  exports: [GroupCustomStatisticsComponent]
})
export class GroupCustomStatisticsModule { }
